import type { Graph, GraphModification } from "@lr-notitia/notitia-designer/schemas";
import { useGraphStore } from "../graph";

let graphStore: ReturnType<typeof useGraphStore>;
function init() {
	graphStore = useGraphStore();
}

export function newGraph(): Graph {
	return {
		domainId: "",
		descriptor: {
			en: {
				term: { value: "", lang: "en" },
				description: { value: "", lang: "en" },
				synonyms: [],
			},
		},
		defaultLanguage: "en",
		languages: [],
		archived: false,
		version: "",
		releasedate: 0,
		releasenotes: "",
		changelog: "",
		dependencies: [],
		hash: "",
		nodes: {},
	};
}

export function handleGraphModification(nodes: GraphModification) {
	if (!graphStore) init();
	const ids = Object.keys(nodes);
	ids.forEach((id) => {
		const node = nodes[id];
		if (!node) delete graphStore.graph.nodes[id];
		else graphStore.graph.nodes[id] = node;
	});
}
